import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-carousel-news',
  templateUrl: './carousel-news.component.html',
  styleUrls: ['./carousel-news.component.sass']
})
export class CarouselNewsComponent implements OnInit {

  constructor(private global:GlobalService) { }

  ngOnInit() {
  }
  navNews(){
    this.global.validateSession();
  }
}
